<template lang="pug">
  .ordering-success
    .success-content
      .success-content-header
        .icon
        .label {{$t('ORDER_COMPLETE')}}

      .success-message {{$t('ORDER_COMPLETE_DESCRIPTION', {pid})}}

      kraus-button(:icon="iconDownload", :label="$t('DOWNLOAD_ORDER_PDF')", :border="true" @click="onDownloadClick")
</template>
<script>
import KrausButton from '@/components/_common/ui/KrausButton';
import { eventBus } from '../../main';
import { mapActions, mapGetters } from 'vuex';
import EventBusEvents from '../../common/EventBusEvents';
export default {
  name: 'OrderingSuccess',
  components: { KrausButton },
  props: ['projectId', 'pid'],
  data() {
    return {
      iconDownload: require('@/assets/images/ui/icon-download.svg')
    }
  },

  computed: {
    ...mapGetters([
      'production'
    ])
  },

  methods: {
    ...mapActions([
      'setEditorType'
    ]),

    onDownloadClick() {
      const a = document.createElement('a')
      a.href = this.production ? 'https://api.kraus-blocks.ru/order/pdf/' + this.projectId : 'https://api.dev.kraus-blocks.ru/order/pdf/' + this.projectId
      a.target = '_blank'
      a.click()
      setTimeout(() => {
        a.remove()
      })
    }
  }
}
</script>
